import { create } from "zustand";

interface GlobalAudioStore {
  currentPlayingAudioRef: { stopAllAudio: () => void } | null;
  setCurrentPlayingAudio: (ref: { stopAllAudio: () => void } | null) => void;
  stopCurrentAudio: () => void;
}

export const useGlobalAudioStore = create<GlobalAudioStore>((set, get) => ({
  currentPlayingAudioRef: null,

  setCurrentPlayingAudio: (ref) => {
    const current = get().currentPlayingAudioRef;
    if (current && current !== ref) {
      current.stopAllAudio();
    }
    set({ currentPlayingAudioRef: ref });
  },

  stopCurrentAudio: () => {
    const current = get().currentPlayingAudioRef;
    if (current) {
      current.stopAllAudio();
    }
    set({ currentPlayingAudioRef: null });
  },
}));
